module.exports = __webpack_public_path__ + "img/b6.2cc4816.jpg";